export const ACCESS_EXPIRED_ERROR_CODE = 'ACCESS_EXPIRED';